import React from 'react'

type RowExpandedPropertyProps = {
	label: string
	value: string | null | React.ReactNode
	className?: string
}

const RowExpandedProperty = ({
	label,
	value,
	className = undefined,
}: RowExpandedPropertyProps) => {
	return (
		<div className={className}>
			<p className="font-rubik text-sm text-slate-500 font-bold mb-1 dark:text-slate-400">
				{label}
			</p>
			<p className="whitespace-normal font-rubik text-slate-800 font-bold mb-3 text-ellipsis overflow-hidden dark:text-white">
				{value}
			</p>
		</div>
	)
}

export default RowExpandedProperty
